// extracted by mini-css-extract-plugin
export default {"divider":"SessionTimeout_divider__gN6Kh","message":"SessionTimeout_message__y55zT"};